import React, {useContext, useRef, useState} from 'react';
import {AgentContext} from "../../context/agent-context.jsx";
import ConfirmationDeleteList from "../../../../../../components/utils/confirmation-delete-lists.jsx";
import GenericEditRemoveCellRenderer from "./generic-edit-remove-cell-renderer.jsx";
import {FaPlus} from "react-icons/fa";
import {AgGridReact} from "ag-grid-react";
import { v4 as uuidv4 } from 'uuid';
import {Card} from "../../../../../../components/card/card.jsx";
import aggridUtils from "../../../../../../utils/aggrid-utils.js";
import {Modal} from "../../../../../../components/modal/modal.jsx";
import InputTextarea from "../../../../../../components/input/input-textarea.jsx";
import SelectComponent from "../../../../../../components/select/select-component.jsx";
import optionsUtils from "../../../../../../utils/options-utils.js";
import Button from "../../../../../../components/button/button.jsx";
import SentryRow from "../../../../../../components/template/sentry-row.jsx";

const SkillsRestriction = () => {
    const generateInitialData = () => ({
        itemId: uuidv4(),
        type: null,
        description: ""
    });

    const {user, setUser, setChanges} = useContext(AgentContext)
    const [data, setData] = useState(generateInitialData)
    const [open, setOpen] = useState(false);
    const gridRef = useRef();

    const remove = (data) => {
        ConfirmationDeleteList(() => {
            setUser(prev => ({
                ...prev,
                skillsRestriction: prev.skillsRestriction.filter(dep => dep.itemId !== data.itemId)
            }));

            setChanges('skillsRestriction');
        })
    }

    const [columnDefs] = useState([
        { headerName: "Tipo",  field: "type",  flex: 1,
            valueFormatter: ({value}) => {
                const action = optionsUtils.skillsRestrictionType.find(option => option.value === value)
                if (action) return action.label;

                return null;
            }, comparator: aggridUtils.nullLastComparator
        },
        { headerName: "Descrição",  field: "description", flex: 1, comparator: aggridUtils.nullLastComparator},
        { headerName: "",  field: "", width: 100,
            cellRenderer: GenericEditRemoveCellRenderer,
            cellRendererParams: {setData, setOpen, remove}
        },
    ]);

    const handleInputs = ({target: {value, id}}) => setData(prev => ({...prev, [id]: value}));

    const save = () => {
        setUser(prevItems => {
            const exists = prevItems.skillsRestriction.some(t => t.itemId === data.itemId);

            const updated = exists
                ? prevItems.skillsRestriction.map(t => (t.itemId === data.itemId ? data : t))
                : [...prevItems.skillsRestriction, data];

            return {
                ...prevItems,
                skillsRestriction: updated
            };
        });

        setChanges('skillsRestriction');
        onHide();
    }

    const onHide = () => {
        setData(generateInitialData());
        setOpen(false)
    }
    return (
        <>
            <Card>
                <Card.Header className={"gap-2"}>
                    <Card.Title>Aptidões e restrições</Card.Title>
                    <Button className={"h-[30px] w-[30px] !p-0"} onClick={() => setOpen(true)}>
                        <FaPlus/>
                    </Button>
                </Card.Header>
                <Card.Body>
                    <div className={"h-[calc(100vh-196px)]"}>
                        <AgGridReact
                            ref={gridRef}
                            rowData={user.skillsRestriction ?? []}
                            columnDefs={columnDefs}
                            animateRows={false}
                            suppressCellFocus={true}
                            gridOptions={{localeText: aggridUtils.localization()}}
                            theme={aggridUtils.generalTheme()}
                        />
                    </div>
                </Card.Body>
            </Card>

            <Modal overflow={true} isCloseClick={false} open={open} setOpen={onHide}  className={"w-4/12"} title={data.itemId ? "Editar" : "Adicionar"}>
                <Modal.Body className="p-2">
                    <SentryRow>
                        <div className="col-span-12">
                            <SelectComponent
                                id="type"
                                value={optionsUtils.skillsRestrictionType.find(option => option.value === data.type)}
                                options={optionsUtils.skillsRestrictionType}
                                label={"Tipo"}
                                onChange={(selected) => setData(prev => ({...prev, type: selected.value}))}
                            />
                        </div>

                        <div className="col-span-12">
                            <InputTextarea id="description" value={data.description} label="Descrição" style={{height: "250px"}} onChange={handleInputs}/>
                        </div>
                    </SentryRow>
                </Modal.Body>

                <Modal.Footer className={"p-2"}>
                    <div className={"w-full flex justify-end"}>
                        <Button onClick={save}>
                            Confirmar
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default SkillsRestriction;